var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 10.5087 29.2332 5.6641 25.0179 2.7826L16 2.08691L6.98206 2.78254C2.76687 5.6641 0 10.5087 0 16C0 21.4914 2.76687 26.3359 6.98206 29.2174L16 29.913L25.0179 29.2174C29.2332 26.3359 32 21.4914 32 16Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0181 2.78262C22.4502 1.02725 19.3454 0 16.0001 0C12.6549 0 9.54999 1.02725 6.98218 2.78262H25.0181Z",
    fill: "#A2001D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98218 29.2173C9.54993 30.9727 12.6549 32 16.0001 32C19.3454 32 22.4502 30.9727 25.0181 29.2173H6.98218Z",
    fill: "#A2001D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 23.6523C20.2263 23.6523 23.6523 20.2263 23.6523 16.0001C23.6523 11.7739 20.2263 8.3479 16.0001 8.3479C11.7739 8.3479 8.3479 11.7739 8.3479 16.0001C8.3479 20.2263 11.7739 23.6523 16.0001 23.6523Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 22.2609C19.4577 22.2609 22.2607 19.4578 22.2607 16.0001C22.2607 12.5423 19.4577 9.7392 15.9999 9.7392C12.5421 9.7392 9.73901 12.5423 9.73901 16.0001C9.73901 19.4578 12.5421 22.2609 15.9999 22.2609Z",
    fill: "#6DA544"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 20.1739C18.3054 20.1739 20.1742 18.3052 20.1742 16C20.1742 13.6948 18.3054 11.826 16.0002 11.826C13.695 11.826 11.8263 13.6948 11.8263 16C11.8263 18.3052 13.695 20.1739 16.0002 20.1739Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 14.9565L13.739 16V17.7392L15.9999 19.1305L18.2607 17.7392V16L15.9999 14.9565Z",
    fill: "#0052B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.739 13.9131H18.2607V16.0001H13.739V13.9131Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBz);
export default __webpack_public_path__ + "static/media/BZ.14265c78.svg";
export { ForwardRef as ReactComponent };